<template>
  <form @submit.prevent="trolleyStore.applyPromoCode()">
    <TsInput
      v-model.uppercase="trolleyStore.promo_code_text"
      append-class="py-0 mb-4 rounded-md px-1"
      input-class="py-2"
      :placeholder="placeholderLabel"
      data-testid="coupon-code-input"
    >
      <template #right>
        <TsButton
          :disabled="!trolleyStore.promo_code_text"
          type="submit"
          :label="useTranslation('apply', 'Toepassen')"
          :isLoading="trolleyStore.is_promo_code_apply_button_loading"
          size="xs"
        />
      </template>
    </TsInput>
  </form>
</template>

<script lang="ts" setup>
import { useTranslation } from "~/composables/useTranslation";

const trolleyStore = useTrolleyStore();
const placeholderLabel = useTranslation(
  "enterCouponCode",
  "Voer couponcode in"
);
</script>
